import { render, staticRenderFns } from "./configDetail.vue?vue&type=template&id=19935556&scoped=true&"
import script from "./configDetail.vue?vue&type=script&lang=js&"
export * from "./configDetail.vue?vue&type=script&lang=js&"
import style0 from "./configDetail.vue?vue&type=style&index=0&id=19935556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19935556",
  null
  
)

export default component.exports